module.exports = __webpack_public_path__ + "img/homepage_1@2x.c9f2174e.jpg";